module.exports = __webpack_public_path__ + "static/warfighting-311b9283954045daea73ef81691bf641.jpg";